import { useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from 'react'
import ErrorHandler from '../../lib/errorHandler';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import FilterListIcon from '@mui/icons-material/FilterList';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import NoDataFound from '../../Component/Common/NoDataFound';
import StatusButton from '../../Component/Common/StatusButton';
import { standardDateFormat } from '../../lib/standardDateFormat';
import StyledTableRow from '../../Component/Common/StyledTableRow';
import IconBackground from '../../Component/Common/IconBackground';
import StyledTableCell from '../../Component/Common/StyledTableCell';
import CommonPagination from '../../Component/Common/CommonPagination';
import { categoryNameOptions, POTypeOptions, Title, useCommonStyles } from '../../utils';
import { Badge, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import { deletePurchaseOrder, getPurchaseOrderById, getPurchaseOrders } from '../../Redux/Actions/PurchaseOrder';
import AddProcessingUnit from '../../Component/ProcessingUnit/AddProcessingUnit';
import { getProcessItemById, getProcessItems } from '../../Redux/Actions/Processing';
import { useAppSelector } from '../../Redux/app/hooks';
import CommonSearchField from '../../Component/Common/CommonSearchField';
import CustomDrawer from '../../Component/Common/CustomDrawer';

const ProcessingUnitList = () => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // =============== States ===============
    const [page, setPage] = useState(1);
    const [selectedItem, setSelectedItem] = useState({});
    const [listData, setListData] = useState({});
    const [isOpenAddProcessingUnit, setIsOpenAddProcessingUnit] = useState(false);
    const [data, setData] = useState({})
    const [purchaseOrderListData, setPurchaseOrderListData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [isOpenFilterDrawer, setIsOpenFilterDrawer] = useState(false);
    const [productName, setProductName] = useState("");

    const initialFilterState = {
        machineName: [],
        processing_type: ""
    };

    const [filterData, setFilterData] = useState(initialFilterState)
    const [isApllyFilter, setIsApplyFilter] = useState(1);
    const filterDataCount = (filterData?.machineName?.length > 0 ? filterData?.machineName?.length : 0) + (filterData?.processing_type?.trim() ? 1 : 0)

    // =============== Handler ===============
    let PerPage = 10
    const tabelHeader = ["SR.", "Propduct Name", "Processing Date", "Machine Name", "Input", "Output", "Wastage", "Action"]

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
    const handleChangePage = (e, p) => {
        setPage(p);
    };

    // ============= get Inventories API =============
    const _getProcessItems = async (p) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "limit": PerPage,
            "page": p ? p : page,
            "search": searchValue,
            "machineName": isApllyFilter ? (filterData?.machineName?.length > 0 ? filterData?.machineName : null) : null,
            "processing_type": isApllyFilter ? (filterData?.processing_type?.trim() ? filterData?.processing_type : null) : null,
        }
        response = await dispatch(getProcessItems(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Get By Id Inventory Field API =============
    const _getPurchaseOrderById = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getProcessItemById(body));
        // console.log(response, 'data response')
        // console.log(response?.payload?.data?.response?.productQuantity, 'data response')
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {

                const res = response?.payload?.data?.response
                setSelectedItem(response?.payload?.data?.response)
                setProductName(res.productId)
                setIsOpenAddProcessingUnit(true)
                setData({
                    ...data,
                    "processingDate": res?.processing_date,
                    "machineName": { name: res?.machineName },
                    "jobWork": { name: res?.processing_type },
                    "lotNumber": { lotNumber: res?.lotNumber },
                    "category": { name: res?.categoryName },
                    // "purchaseOrderListData": res?.purchaseOrder,
                    "totalQuantity": res?.totalQuantity,
                    "totalQuantity": res?.output,
                    "wastage1": res?.firstWastage,
                    "wastage2": res?.secondWastage,
                    "wastage3": res?.thirdWastage,
                    "totalOutput": res?.finalOutput,
                    "remarks": res?.description,
                    "productId": response?.payload?.data?.response?.productId,
                    "productQuantity": response?.payload?.data?.response?.productQuantity
                })
                setPurchaseOrderListData(res?.purchaseOrder)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // =============== Use Effects ===============
    useEffect(() => {
        if (searchValue) {
            _getProcessItems();
        } else {
            _getProcessItems();
        }
    }, [page, searchValue])
    
    useEffect(() => {
        setPage(1);
    }, [searchValue]);

    useEffect(() => {
        setPage(1)
        _getProcessItems(1);
    }, [isApllyFilter])



    return (
        <>
            {isOpenAddProcessingUnit ?
                <AddProcessingUnit setProductName={setProductName} productName={productName} setSearchValue={setSearchValue} selectedItem={selectedItem} setSelectedItem={setSelectedItem} setIsOpenAddProcessingUnit={setIsOpenAddProcessingUnit} setData={setData} data={data} _getProcessItems={_getProcessItems} setPurchaseOrderListData={setPurchaseOrderListData} purchaseOrderListData={purchaseOrderListData} />
                :
                <Grid container spacing={2} padding={"25px"}>
                    <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>Processing Unit List</Typography>
                        <Box display={"flex"} gap={1} flexWrap={'wrap'}>
                            <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["Machine Name"]} />
                            <Badge badgeContent={filterDataCount || 0} sx={{ "& .MuiBadge-badge": { right: "4px", top: "10px", zIndex: 999, color: "#FFF" } }} color="primary">
                                <Button className={classes.cancelButton} startIcon={<FilterListIcon />} onClick={() => setIsOpenFilterDrawer(true)}>Filters </Button>
                            </Badge>
                            {getPermissionList?.editPermission?.includes('Processing') &&
                                <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenAddProcessingUnit(true)}>Add New Processing Unit</Button>
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                            <TableContainer>
                                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                    <TableHead>
                                        <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                            {tabelHeader?.map((ele) => {
                                                return (
                                                    <StyledTableCell>{ele}</StyledTableCell>
                                                )
                                            })}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listData?.response?.length > 0 ?
                                            listData?.response?.map((row, index) => {
                                                const totalWestage = (row?.firstWastage || 0) + (row?.secondWastage || 0) + (row?.thirdWastage || 0);
                                                const formattedWastage = totalWestage % 1 !== 0 ? totalWestage.toFixed(2) : totalWestage;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <StyledTableRow>
                                                            <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                            <StyledTableCell> {row?.productId?.name ? row?.productId?.name : "NA"}</StyledTableCell>
                                                            <StyledTableCell> {row?.processing_date && standardDateFormat(row?.processing_date)}</StyledTableCell>
                                                            <StyledTableCell> {row.machineName ? row.machineName : "NA"}</StyledTableCell>
                                                            {/* <StyledTableCell> {row.lotNumber ? row.lotNumber : "NA"}</StyledTableCell> */}
                                                            <StyledTableCell> {row.totalQuantity ? row.totalQuantity : "0"}</StyledTableCell>
                                                            <StyledTableCell> {row.finalOutput ? row.finalOutput : "0"}</StyledTableCell>
                                                            <StyledTableCell> {formattedWastage ? formattedWastage : "0"}</StyledTableCell>
                                                            <StyledTableCell>
                                                                <Box display={"flex"} justifyContent={"start"} gap={1}>
                                                                    {/* {getPermissionList?.viewPermission?.includes('Processing') &&
                                                                    <IconBackground icon={"visibility"} onClick={() => _getPurchaseOrderById(row?._id)} />
                                                                } */}
                                                                    {getPermissionList?.editPermission?.includes('Processing') &&
                                                                        <IconBackground icon={"edit"} onClick={() => _getPurchaseOrderById(row?._id)} />
                                                                    }
                                                                </Box>
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    </React.Fragment>
                                                )
                                            })
                                            :
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={12}>
                                                    <NoDataFound />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <CommonPagination
                                totalCount={listData?.count}
                                count={Math.ceil(listData?.count / PerPage)}
                                itemsPerPage={PerPage}
                                page={page}
                                onChange={handleChangePage}
                            />
                        </Box>
                    </Grid>
                    <CustomDrawer
                        isOnlyIconClose
                        isDrawerOpen={isOpenFilterDrawer}
                        handleClose={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}
                        title="Filter"
                    >
                        <Grid container p={2}>
                            <Grid item xs={12}>
                                <Title>Machine Name</Title>
                            </Grid>
                            {["C1", "C2", "C3", "C4", "C5", "C6"].map((ele) => {
                                const isChecked = filterData.machineName.includes(ele);
                                return (
                                    <Grid item xs={12} sm={6} md={4} key={ele}>
                                        <FormControl component="fieldset">
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={isChecked}
                                                            onChange={(e) => {
                                                                setFilterData((prev) => ({
                                                                    ...prev,
                                                                    machineName: e.target.checked
                                                                        ? [...prev.machineName, ele]
                                                                        : prev.machineName.filter((item) => item !== ele)
                                                                }));
                                                            }}
                                                        />
                                                    }
                                                    sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                    label={ele}
                                                    labelPlacement="end"
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                );
                            })}
                            <Grid item xs={12}>
                                <Title>Job Work</Title>
                            </Grid>
                            {["Job work", "Regular"].map((ele) => {
                                return (
                                    <Grid item xs={12} sm={6} md={4} key={ele}>
                                        <FormControl component="fieldset">
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={<Checkbox checked={filterData.processing_type === ele}
                                                        onChange={() => { setFilterData((prev) => ({ ...prev, processing_type: ele })) }} />}
                                                    sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                    label={ele}
                                                    labelPlacement="end"
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                );
                            })}
                            <Grid item xs={12} mt={2} display="flex" justifyContent="end" gap={2}>
                                <Button className={classes.cancelButton}
                                    onClick={() => {
                                        setFilterData(initialFilterState);
                                        //   setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) 
                                    }
                                    }>
                                    Reset Filter
                                </Button>
                                <Button className={classes.saveButton} onClick={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}>
                                    Apply Filter
                                </Button>
                            </Grid>
                        </Grid>
                    </CustomDrawer>
                </Grid>
            }
        </>
    )
}

export default ProcessingUnitList